import { ICellRendererParams } from "ag-grid-community";
import React from "react";

import { IgLink } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  FullAgencyDto,
  OrgIdNameDto,
} from "@intelligems/ig-types";
import { usePostStripeProductLink } from "@src/api/stripe-product-links/post-stripe-product-link";

export const GrantAccessColumn = (
  params: ICellRendererParams<OrgIdNameDto>
) => {
  const context = params.context as {
    item: AgencySubscriptionItemDto;
    subscription: AgencySubscriptionDto;
    agency: FullAgencyDto;
  };

  const postStripeProductLink = usePostStripeProductLink(context.agency.id);

  if (!params.data || !params.data?.id) {
    return null;
  }

  const stripeSubscriptionLink =
    context.subscription.stripeSubscriptionLinks.find(
      (sl) => sl.organizationId === params.data!.id
    );

  return (
    <IgLink
      disabled={postStripeProductLink.isPending}
      onClick={() => {
        postStripeProductLink.mutate({
          body: {
            stripeProductLink: {
              stripeProductId: context.item.product.stripeProductId,
              stripeSubscriptionId: context.subscription.stripeSubscriptionId,
              stripeSubscriptionLinkId: stripeSubscriptionLink?.id || null,
              organization: params.data!,
            },
          },
          pathParams: {},
          queryParams: undefined,
        });
      }}
    >
      Grant Access
    </IgLink>
  );
};
